import { useEffect, useState } from 'react';
import AgentComposer from './AgentComposer';

/**
 * LumiereEntryOverlay — la entrada a Studio Media Labs con Lumière como
 * protagonista.
 *
 * El Studio carga normal (último proyecto incluido) y queda visible detrás,
 * difuminado: esta capa sólo abre el Lumière que ya existe (`AgentComposer`)
 * en su variante "entrada". No hay un segundo chat ni lógica duplicada.
 *
 * Se muestra en CADA entrada a la plataforma y se puede volver a abrir en
 * cualquier momento con el botón "Lumière" de la barra superior (o con
 * `window.dispatchEvent(new Event('lumiere:open'))`).
 */
export const LumiereEntryOverlay = () => {
  // Ya NO se auto-abre al entrar (limpieza previa al rediseño de entrada).
  // Se sigue abriendo manual con el botón "Lumière" de la barra o con
  // `window.dispatchEvent(new Event('lumiere:open'))`. Para reactivar la
  // apertura automática: useState(true).
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener('lumiere:open', onOpen);
    return () => window.removeEventListener('lumiere:open', onOpen);
  }, []);

  return (
    <AgentComposer
      open={open}
      variant="entry"
      onClose={() => setOpen(false)}
    />
  );
};

export default LumiereEntryOverlay;
